import { Checkbox as ToolkitCheckbox } from '@tractian/ui'
import type { CheckboxProps } from '@tractian/ui'

export function Checkbox(props: CheckboxProps) {
  return (
    <ToolkitCheckbox {...props}>
      <ToolkitCheckbox.Indicator />
    </ToolkitCheckbox>
  )
}

export type { CheckboxProps }
